export const HelpSupport = [
  {
    id: "accountStatus",
    title: "Account Status",
    message: "Your account is inactive.",
    text: "If you see this message, it means your account is no longer active. This could be due to non-payment or issues with your account usage. Please contact support to resolve this issue.",
  },
  {
    id: "emailVerification",
    title: "Email Verification",
    message:
      "Your email has not been verified yet. Please click on 'Resend Verification Email' to get started.",
    text: "This indicates that you are a part of Rulebook Company, but your email address hasn't been verified. Click on Resend Verification Email and follow the instructions to verify your email and get started.",
  },
  {
    id: "useRulebookCompany",
    title: "How can I use Rulebook Company?",
    message: "",
    text: "To start using Rulebook Company, please email us with the list of fee schedules you want to monitor. Changing Your Password",
  },
  {
    id: "changePassword",
    title: "How to change my password?",
    message: "",
    text: "",
    list: [
      "Click on your Avatar at the top right corner.",
      'Select "My Profile."',
      ' Click on "Edit."',
      ' Update your password by clicking on "Update."',
    ],
  },
  {
    id: "changeEmail",
    title: "Can I change my email?",
    message: "",
    text: "Yes, you can change your email address. However, you'll need to verify the new email to complete the change. Terminology: Last Checked and Last Updated",
  },
  {
    id: "lastCheckedLastUpdated",
    title: "What does Last Checked and Last Updated mean?",
    message: "",
    text: "",
    list: [
      '"Last Checked:" The last time our system reviewed the fee schedule to see if new files were uploaded.',
      '"Last Updated:" The last time our system detected any changes to the fee schedule. This helps you track the most recent updates from',
    ],
  },
  {
    id: "recentSupplier",
    title: "What are Recent Supplier Updates?",
    message: "",
    text: 'The "Recent Supplier Updates" section on the dashboard shows the most recently updated suppliers. This feature keeps you informed about the latest changes.',
  },
];
